"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductChangeLog = void 0;
const date_fns_1 = require("date-fns");
const tracking_1 = require("@/services/tracking");
const tracking_2 = require("@/store/ducks/tracking");
function getProductChangeLog(pageIndex, pageSize) {
    return (dispatch) => {
        dispatch((0, tracking_2.getTrackingData)());
        (0, tracking_1.getChangeLog)(pageIndex, pageSize, {
            name: "affectedTable",
            value: "Products",
        })
            .then((response) => {
            if (response.length === 0) {
                dispatch((0, tracking_2.setHasEndingTrackingData)());
            }
            const changelog = response.map((productChanges) => {
                return buildProductChangelog(productChanges);
            });
            dispatch((0, tracking_2.getTrackingDataSuccess)(changelog));
        })
            .catch(() => {
            dispatch((0, tracking_2.getTrackingError)());
        });
    };
}
exports.getProductChangeLog = getProductChangeLog;
const buildProductChangelog = (productChange) => {
    return {
        operationTitle: defineOperationTitle(productChange.operation),
        affectedEntityName: getAffectedEntityName(productChange.data),
        logDate: getChangelogDate(productChange.data),
        user: productChange.userId,
        operation: productChange.operation,
        logCreationDate: productChange.createdAt
    };
};
const defineOperationTitle = (operation) => {
    switch (operation) {
        case "UPDATE":
            return "Product changed";
        case "CREATE":
            return "Added new product";
        case "DELETE":
            return "Product deleted";
        default:
            return "Operation not detected";
    }
};
const getAffectedEntityName = (data) => {
    try {
        if (data) {
            const parsedData = JSON.parse(data);
            return parsedData.name;
        }
    }
    catch (e) {
        throw new Error(`[Products Changelog Error: Error while getting affected entity name - ${e}]`);
    }
};
const getChangelogDate = (data) => {
    try {
        if (data) {
            const parsedData = JSON.parse(data);
            const date = parsedData.operation === "DELETE"
                ? parsedData.deletedAt
                : parsedData.updatedAt;
            return (0, date_fns_1.format)(new Date(date), "dd MMM y | H:m:s");
        }
    }
    catch (e) {
        throw new Error(`[Products Changelog Error: Error while getting log date - ${e}]`);
    }
};
